import { format } from 'sql-formatter';

/**
 * Pretty-print SQL with parameter-aware formatting. `{{name}}` placeholders (time-range
 * bindings like `{{range_start}}`) are treated as named params so the formatter doesn't
 * mangle the braces. Falls back to the raw input when it can't parse — so a half-typed or
 * unsupported query is left byte-exact rather than reflowed into garbage.
 *
 * Dialect is `postgresql`, not the generic ANSI `sql`: the ANSI grammar throws on `::` casts
 * (swallowed by the catch, so formatting silently no-ops) and — worse — reflows `->`/`->>`
 * JSON operators into `- > >` without throwing, corrupting the query. `postgresql` round-trips
 * both, and every warehouse this app connects to is a Postgres-family dialect.
 *
 * Single source of truth for every SQL surface (workflow editor, dashboard "View SQL", chat
 * activity). Idempotent: formatting already-formatted SQL is a no-op.
 */
export function formatSql(sql: string): string {
  if (!sql.trim()) return sql;
  try {
    return format(sql, {
      language: 'postgresql',
      keywordCase: 'upper',
      tabWidth: 2,
      paramTypes: { custom: [{ regex: String.raw`\{\{[^}]+\}\}` }] },
    });
  } catch {
    return sql;
  }
}
